import { cn } from '../../shadcn';
import type { FieldMessageProps } from '../types';

function FieldMessage({ className, message, messageType, actionElement, disabled, ...props }: FieldMessageProps) {
  const classes = {
    wrapper: 'flex justify-between mt-2 data-[disabled=true]:pointer-events-none data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50',
    message: `paragraph-s-strong ${messageType === 'error' && message && 'text-error-foreground'} ${messageType === 'success' && message && 'text-success-800'}`,
    action: 'underline cursor-pointer link-label-s',
  };

  if (!message && !actionElement) return null;

  return (
    <div {...props} className={cn(classes.wrapper, className)} data-disabled={disabled}>
      <span className={classes.message} aria-live="polite" aria-hidden={!message} role="status" data-testid="field-message">
        {message}
      </span>
      {actionElement && <span className={classes.action}>{actionElement}</span>}
    </div>
  );
}

export { FieldMessage };
